<template>
    <div class="video-redirection-box">
        <div class="video-redirection-box__inner">
            <div class="video-redirection-box__inner-content" :class="{ 'video-redirection-box__content-hidden': isContentHidden }">
                <p>{{ $t('CourseVideo.redirection_countdown_next_part') }}</p>
                <p v-if="nextVideoTitle"><strong>"{{ nextVideoTitle }}"</strong></p>
                <p>{{ $t('CourseVideo.redirection_countdown_starting_in') }}</p>

                <div class="video-redirection-box__spinner">
                    <div :class="{'paused' : isRatingModalVisible}" class="spinner-circle"></div>
                    <span class="counter">{{countdownNumber}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        props: {
            nextVideoTitle: String,
            countdown: Number,
        },
        data () {
            return {
                countdownNumber: 3,
                countdownInterval: null,
                isContentHidden: false
            }
        },
        computed: {
            ...mapGetters({
                isRatingModalVisible: 'VideoPlayer/getIsRatingModalVisible'
            })
        },
        beforeMount () {
            this.countdownNumber = this.countdown
            this.countdownInterval = setInterval(() => {
                if (this.countdownNumber > 0 && !this.isRatingModalVisible) {
                    this.countdownNumber--
                }

                if (this.countdownNumber === 0 && !this.isContentHidden) {
                    this.isContentHidden = true
                    this.$emit('countDownComplete')
                }
            }, 1000)
        },
        beforeDestroy () {
            clearInterval(this.countdownInterval)
            this.countdownNumber = 0
            this.isContentHidden = false
        }
    }
</script>

<style lang="scss" scoped>
.video-redirection-box {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background: $cod_gray;
    z-index: 100;
    color: $white;
    font-size: 1.5rem !important;

    &__inner {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;

        p {
            margin: 8px 12px
        }
    }

    &__spinner {
        position: relative;
        margin-top: 12px;

        .counter {
            position: absolute;
            top: 12px;
            left: 0;
            width: 100%;
            text-align: center;
            font-size: 3rem;
            font-weight: bold;
        }

        .spinner-circle {
            margin: 0 auto;
            padding: 0;
            width: 60px;
            height: 60px;
            border-radius: 50%;
            background: radial-gradient(farthest-side, $white 94%,#0000) top/5px 5px no-repeat,
            conic-gradient(#0000 30%, $white);
            -webkit-mask: radial-gradient(farthest-side,#0000 calc(100% - 5px),#000 0);
            animation: spinner-animation 1.2s infinite linear;
        }

        @keyframes spinner-animation {
            100% {
                transform: rotate(1turn);
            }
        }

        .paused {
            animation-play-state: paused;
        }
    }

    &__content-hidden {
        visibility: hidden;
        opacity: 0;
        transition: visibility 0s 1s, opacity 1s linear;
    }

    [class*="desktop_l"] & {
        font-size: 1.3rem !important;

        &__inner p {
            margin: 8px 12px;
        }

        &__spinner {
            margin-top: 20px;

            .counter {
                top: 24px;
                font-size: 3rem;
            }

            .spinner-circle {
                width: 80px;
                height: 80px;
                background: radial-gradient(farthest-side, $white 94%,#0000) top/9px 9px no-repeat,
                conic-gradient(#0000 30%, $white);
                -webkit-mask: radial-gradient(farthest-side,#0000 calc(100% - 9px),#000 0);
            }
        }
    }

    [class*="desktop_xl"] & {
        font-size: 2rem !important;

        &__inner p {
            margin: 10px 24px;
        }

        &__spinner {
            margin-top: 52px;

            .counter {
                top: 28px;
                font-size: 4rem;
            }

            .spinner-circle {
                width: 100px;
                height: 100px;
                background: radial-gradient(farthest-side, $white 94%,#0000) top/9px 9px no-repeat,
                    conic-gradient(#0000 30%, $white);
                -webkit-mask: radial-gradient(farthest-side,#0000 calc(100% - 9px),#000 0);
            }
        }
    }

    [class*="desktop_xxl"] &,
    [class*="desktop_xxxl"] & {
        font-size: 2.5rem !important;

        &__inner p {
            margin: 16px 24px;
        }

        &__spinner {
            margin-top: 52px;

            .counter {
                top: 52px;
                font-size: 6rem;
            }

            .spinner-circle {
                width: 174px;
                height: 174px;
                background: radial-gradient(farthest-side, $white 94%,#0000) top/14.1px 14.1px no-repeat,
                    conic-gradient(#0000 30%, $white);
                -webkit-mask: radial-gradient(farthest-side,#0000 calc(100% - 14.1px),#000 0);
            }
        }
    }
}
</style>
